function getElectronBridge<M>(): Partial<M> | undefined {
  return (window as unknown as { electronAPI?: Partial<M> }).electronAPI;
}

async function callBridge<M, T>(
  tag: string,
  method: keyof M & string,
  invoke: (bridge: Partial<M>) => Promise<T> | undefined,
  fallback: T,
): Promise<T> {
  const bridge = getElectronBridge<M>();
  if (!bridge) return fallback;
  try {
    const result = await invoke(bridge);
    return result === undefined ? fallback : result;
  } catch (error) {
    console.warn(`[${tag}] ${method} failed over IPC`, error);
    return fallback;
  }
}

export function createBridgeClient<M>(
  tag: string,
  methods: readonly (keyof M & string)[],
) {
  return {
    hasAllMethods(): boolean {
      const bridge = getElectronBridge<M>();
      if (!bridge) return false;
      return methods.every((name) => typeof bridge[name] === "function");
    },
    call<T>(
      method: keyof M & string,
      invoke: (bridge: Partial<M>) => Promise<T> | undefined,
      fallback: T,
    ): Promise<T> {
      return callBridge(tag, method, invoke, fallback);
    },
  };
}
